import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import Contents from './Contents.jsx';
import AllHeader from './Header.jsx';
import AllFooter from './Footer.jsx';

import "../css/Page.css";

export default function Page() {
  return (
    <div>
      <div className="main">
        <AllHeader />
        <Contents />
        <AllFooter />
      </div>
    </div>
  );
}
